import React from "react";
import "./index.scss";

const PlatformDisclaimer = () => (
  <aside className="platform-disclaimer" role="note" aria-label="Platform disclaimer">
    Workbrook is a software platform facilitating peer-to-peer networking, not a
    traditional employment agency representing candidates.
  </aside>
);

export default PlatformDisclaimer;
